import { SpaceVertical } from '@looker/components';
import styled from 'styled-components';

export const StyledStepWrapper = styled(SpaceVertical)`
  width: 100%;
  min-height: 100%;
  padding: 20px;
  border-radius: 6px;
  background: white;
  box-shadow: 0px 5px 20px -2px rgba(0, 0, 0, 0.12);
`;
